module.exports = __webpack_public_path__ + "static/media/i30.bb67da60.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/i30.svg
// module id = 405
// module chunks = 12